module.exports = __webpack_public_path__ + "static/img/hahmo-tekijanoikeuden-luovuttaminen.0e705c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hahmo-tekijanoikeuden-luovuttaminen.png
// module id = wQBG
// module chunks = 1